// import axios from "axios";

// const axiosInstance = axios.create({
//   baseURL: import.meta.env.VITE_BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//   },
// });

// // Request Interceptor: Ensure latest token is used
// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Response Interceptor: Handle Expired Tokens
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     if (error.response && error.response.status === 400) {
//       console.warn("Token expired or invalid. Logging out...");

//       // Clear token and redirect to login
//       localStorage.removeItem("token");
//       window.location.href = "/login"; // Redirect to login page
//     }
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;

// import axios from "axios";

// const token = localStorage.getItem("token");

// const axiosInstance = axios.create({
//   baseURL: import.meta.env.VITE_BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//     Authorization: `Bearer ${token}`,
//   },
// });

// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");

//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     } else {
//       console.warn("No token found in sessionStorage");
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);

//   }
// );

// export default axiosInstance;

// src/utils/axiosInstance.js
import axios from "axios";
import { toast } from "react-toastify";
import { encryptData, decryptData } from "./encryptionHelper";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      // if (config.data && !config._isEncrypted) {
      //   const encryptedPayload = encryptData(config.data);
      //   if (encryptedPayload.iv || !config.data.iv) {
      //     config.data = encryptedPayload;
      //   }
      // }
    } catch (error) {
      console.error("Request encryption error:", error);
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// Response Interceptor
// axiosInstance.interceptors.response.use(
//   (response) => {
//     // Handle backend returning unauthorized as string with 200 status
//     if (
//       typeof response.data === "string" &&
//       response.data.toLowerCase().includes("unauthorized")
//     ) {
//       localStorage.removeItem("token");
//       toast.error("Session expired. Please login again.");
//       window.location.href = "/login";
//     }

//     return response;
//   },
//   (error) => {
//     const status = error?.response?.status;
//     const message = error?.response?.data?.message;

//     console.error("Axios error:", error);

//     if (status === 401 || message === "Invalid Authentication") {
//       localStorage.removeItem("token");
//       toast.error("Unauthorized! Please login again.");
//       window.location.href = "/login";
//     }

//     return Promise.reject(error);
//   }
// );
// axiosInstance.interceptors.response.use(
//   (response) => {
//     try {
//       if (response.data && response.data.encrypted) {
//         response.data = decryptData(response.data);
//       }
//     } catch (error) {
//       console.error("Response decryption error:", error);
//     }
//     return response;
//   },
//   (error) => {
//     try {
//       // Decrypt error response if it's encrypted
//       if (
//         error.response &&
//         error.response.data &&
//         error.response.data.encrypted
//       ) {
//         error.response.data = decryptData(error.response.data);
//       }
//     } catch (decryptError) {
//       console.error("Error response decryption failed:", decryptError);
//     }
//     return Promise.reject(error); // still reject so catch() runs
//   }
// );

//---------------------------------

axiosInstance.interceptors.response.use(
  (response) => {
    try {
      // 🔐 Decrypt successful response
      if (response.data && response.data.encrypted) {
        response.data = decryptData(response.data);
      }

      // 🚨 Handle backend returning "unauthorized" as 200 response
      if (
        typeof response.data === "string" &&
        response.data.toLowerCase().includes("unauthorized")
      ) {
        localStorage.removeItem("token");
        toast.error("Session expired. Please login again.");
        window.location.href = "/login";
      }
    } catch (error) {
      console.error("Response decryption error:", error);
    }

    return response;
  },

  (error) => {
    try {
      // 🔐 Decrypt error response if encrypted
      if (
        error.response &&
        error.response.data &&
        error.response.data.encrypted
      ) {
        error.response.data = decryptData(error.response.data);
      }

      const status = error?.response?.status;
      const message = error?.response?.data?.message;

      // console.error("Axios error:", error);
      // console.log("Decrypted error message:", message);

      // 🚨 Auto logout on 401 or invalid auth
      if (status === 401 || message === "Invalid Authentication") {
        localStorage.removeItem("token");
        toast.error("Unauthorized! Please login again.");
        window.location.href = "/login";
      }
    } catch (decryptError) {
      console.error("Error response decryption failed:", decryptError);
    }

    return Promise.reject(error); // Keep rejection so catch() still works
  },
);

//-----------------------------

export default axiosInstance;
